import { COMFORT_VALUE } from '@/features/filter/comfort';

import { useI18n } from '@experience/i18n';
import ru from '../i18n/ru.json';

export const getComfortFilterItems = () => {
  const { t } = useI18n({
    inheritLocale: true,
    messages: {
      ru,
    },
  });

  return {
    WILD: {
      label: t('wild'),
      description: t('wildDescription'),
      value: COMFORT_VALUE.WILD,
    },
    SIMPLE: {
      label: t('simple'),
      description: t('simpleDescription'),
      value: COMFORT_VALUE.SIMPLE,
    },
    STANDARD: {
      label: t('standard'),
      description: t('standardDescription'),
      value: COMFORT_VALUE.STANDARD,
    },
    PREMIUM: {
      label: t('premium'),
      description: t('premiumDescription'),
      value: COMFORT_VALUE.PREMIUM,
    },
  };
};
